// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-container {
    margin-top: 20px;
}

@media (max-width: 1200px) {
    .dynamic-container {
        height: 300px
    }
}


@media (min-width: 1200px) {
    .dynamic-container {
        height: calc(100vh - 550px);
    }
}

.description {
    background-color: #f4f4f4;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/auditlog/downloadauditlogdump.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI;IACJ;AACJ;;;AAGA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB","sourcesContent":[".dynamic-container {\n    margin-top: 20px;\n}\n\n@media (max-width: 1200px) {\n    .dynamic-container {\n        height: 300px\n    }\n}\n\n\n@media (min-width: 1200px) {\n    .dynamic-container {\n        height: calc(100vh - 550px);\n    }\n}\n\n.description {\n    background-color: #f4f4f4;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
